import {Component, OnInit} from '@angular/core';
import {CardConfig} from '@shared/module/card/model';
import {MenuHelperUtils} from '@shared/helper';

@Component({
  selector: 'app-card-no-data',
  templateUrl: './card-no-data.component.html',
  styleUrls: ['./card-no-data.component.scss']
})
export class CardNoDataComponent implements OnInit {
  config!: CardConfig;

  constructor() {
  }

  ngOnInit(): void {
    this.config = {
      headerConfig: {
        title: {label: 'common.card.no-data.title'},
        icon: MenuHelperUtils.INFO_ICON,
      },
      css: 'p-xlarge max-width-600 margin-auto',
    }
  }

}
